import Api from 'api'

const config = {
  baseURL: '/api/app/v2/as',
}
const api = new Api(config)

api.fetchChart = ({ ...rest }) => api.get('/statistics/dates', { ...rest })
api.fetchAccountsStatistics = ({ ...rest }) =>
  api.get('/statistics/accounts', { ...rest })
api.fetchNetworksStatistics = ({ ...rest }) =>
  api.get('/statistics/networks', { ...rest })

api.fetchChartDemo = ({ ...rest }) =>
  api.get('/demo/statistics/dates', { ...rest })
api.fetchAccountsStatisticsDemo = ({ ...rest }) =>
  api.get('/demo/statistics/accounts', { ...rest })
api.fetchNetworksStatisticsDemo = ({ ...rest }) =>
  api.get('/demo/statistics/networks', { ...rest })
api.fetchAccounts = () => api.get('/accounts')

export const URL_FILE_XLS = ({ groupBy }) =>
  `${config.baseURL}/statistics/${groupBy}/export`

export default api
